import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import { DialogActions } from '@mui/material';
const PREFIX = 'DialogFooter';

const classes = {
  root: `${PREFIX}-root`,
  reverse: `${PREFIX}-reverse`,
  row: `${PREFIX}-row`,
};

const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
  [`&.${classes.root}`]: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    padding: '1rem 1.5rem',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
  },

  [`&.${classes.reverse}`]: {
    flexDirection: 'column-reverse',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row-reverse',
    },
  },

  // Keep buttons side by side on mobile too (first child on the left)
  [`&.${classes.row}`]: {
    flexDirection: 'row',
    '& > .MuiButton-root': {
      width: 'auto',
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: '32px',
    },
  },
}));

export default function DialogFooter({ children, reverse = false, row = false, style = null }) {
  return (
    <StyledDialogActions style={style} className={clsx({ [classes.root]: true, [classes.reverse]: reverse, [classes.row]: row })}>
      {children}
    </StyledDialogActions>
  );
}
